var storage = require('../storage');
var config = require('../config').config;
var cacheBuster = '/assets/desktop/icons/icons.svg?v=' + config.cacheBusterSVG + '&';
var raygun = require('../raygun');

function getVirtualGiftList(giftmemberID, memberGender, memberGrade, customerId, siteTranslationPath, config, returnTemplate, notBlocked, sendGiftMessage, notices) {
    return new Promise((resolve, reject) => {
        var formData = new FormData();
        formData.append('memberid', giftmemberID);
        formData.append('gender', memberGender);
        formData.append('memberGrade', memberGrade);
        formData.append('customerId', customerId);
        formData.append('loggedinmemberid', config.memberID);
        var URL = '/' + siteTranslationPath + '/profile/getvirtualGiftList?ajaxMode=true';
        var req = new XMLHttpRequest();
        req.url = URL;
        req.onload = function (req) {
            if (req.currentTarget.status == 200 && req.currentTarget.readyState === XMLHttpRequest.DONE) {
                var data = []
                var result = JSON.parse(req.currentTarget.responseText)
                if (result && result.dataset) {
                    data = result.virtualGifts;
                    var freeAvailable = result.freeAvailable;                
                }
                if (data.length > 0 && returnTemplate) {
                    var htmlOptionsMarkUp = ''
                    // find the sparks star in the navbar and copy
                    var sparksStar = document.querySelector('[data-icon-sparks] svg')
                    // now turn to a string
                    var s = new XMLSerializer();
                    var sparksStarString = s.serializeToString(sparksStar);

                    var freeWaitIcon = '<svg class="flex-none icon-20 absolute top-0 right-0 botton-0 left-0 mx-auto mt2" data-vg-timer=""><use xlink:href="' + cacheBuster + '#icon-stopwatch"></use></svg>';
                    
                    Array.from(data).forEach(function (item) {
                        var giftIconText = 
                            '<img class="fit icon-50' + (item.price == 0 && !freeAvailable ? ' opacity-4 ' : '') + '" src="'+item.image+'" data-vg-icon>'+
                            '<div class="flex items-center justify-center' + (item.price == 0 && !freeAvailable ? ' opacity-4' : '') + '" data-vg-price>'+
                                '<div class="flex-none icon-20">'+
                                sparksStarString +
                                '</div>'+
                                '<p class="h6 m0">'+item.price+'</p>'+
                            '</div>'
                        if (item.price == 0) {
                            var freeIcon = '<div class="specials flex items-center justify-center' + (item.price == 0 && !freeAvailable ? ' opacity-4 ' : '') + '" data-specials>' +
                            '<svg class="flex-none icon-33 fill-green"><use xlink:href="' + cacheBuster + '#icon-vg-burst"></use></svg>' +
                            '<p class="absolute white h6 m0">FREE</p>' +
                                '</div>';
                            
                            giftIconText += freeAvailable? freeIcon : freeIcon+freeWaitIcon;
                        }

                        htmlOptionsMarkUp +='<div class="relative flex-auto mt1 mb2 mx2 center pointer' + (item.price == 0 && !freeAvailable ? ' pointer-events-none' : '') + '" data-sparks-gift="'+item.key+'" data-sparks-price="'+item.price+'">'
                            + giftIconText +
                        '</div>'
                    })
                    var toggleButton = '<div class="icon-50 relative"><div class="icon-20 m1 bg-light-grey p1 circle flex items-center justify-center pointer" data-toggle-sparks>' +
                        '<svg class="flex-none icon-10 fill-action-unhighlight rotate-180"><use xlink:href="' + cacheBuster + '#icon-arrow-down"></use></svg>' +
                        '</div></div>';

                    var optionsWrapper = '<div class="m1 flex flex-wrap justify-between">' + htmlOptionsMarkUp + '</div>'
                    var showHide = (notBlocked) ? '' : 'hide ';
                    var htmlMarkupWrapper = '<div class="'+showHide+'rounded-top max-width-3 fade-in chat-sparks-options col-12 flex justify-between relative" data-toggle-sparks-options>' + optionsWrapper + toggleButton + '</div>'
                    
                    var DOM = document.createRange().createContextualFragment(htmlMarkupWrapper)
                    var toggle = DOM.querySelector('[data-toggle-sparks]');
                    if (toggle) {
                        toggle.addEventListener('click', function(e){toggleSparksOptions(e,false)})
                    }

                    // add click event to each gift
                    var vGifts = DOM.querySelectorAll('[data-sparks-gift]');
                    Array.from(vGifts).forEach(function (gift) {
                        gift.addEventListener('click', function (e) {
                            if (e.currentTarget.dataset.sparksGift) {
                                var currentTarget = e.currentTarget
                                giveGift(giftmemberID, siteTranslationPath, config, gift.dataset.sparksGift, gift.dataset.sparksPrice)
                                .then(function (res) {
                                    if (res.dataset) {
                                        //Use callback passed in at initial setup
                                        if (sendGiftMessage && typeof sendGiftMessage === 'function') {
                                            sendGiftMessage(res.giftImage)
                                        }
                                        updateSparksBalance(res)
                                        //close gift div if open
                                        toggleSparksOptions(e, true)

                                        if (res.message) {
                                            notices.confirm(res.message)
                                        }
                        
                                        if (!res.free.available) {
                                            //update the free gifts state
                                            updateFreeGifts(currentTarget)
                                        }
                                    } else {
                                        // issue with sending gift
                                        if ("message" in res) {
                                            if ("free" in res) {
                                                if (!res.free.available) {
                                                    //update the free gifts state
                                                    updateFreeGifts(currentTarget)
                                                }
                                            }

                                            // show user warining notice
                                            notices.warn(res.message)
                                        } else {
                                            // follow redirect link
                                            window.location = res.redirect ? res.redirect : res.redirectLink
                                        }
                                    }
                                })
                                .catch(function (error) {
                                    raygun.sendError(error, 'giveGiftError');
                                })
                            }
                        })
                    })

                    resolve(DOM)
                } else {
                    resolve(data)
                }
            } else {
                reject('issue loading virtual gifts list')
            }
        };
        req.open('POST', URL);
        req.setRequestHeader("pragma", "no-cache");
        req.setRequestHeader("Cache-control", "no-store, must-revalidate, private");
        req.send(formData);
      });
}

function toggleSparksOptions(e,close) {
    var wrapper = e.target.closest('[data-toggle-sparks-options]');
    if (wrapper) {
        e.stopPropagation();
        e.preventDefault();
        if(close){
            wrapper.classList.remove('open');
            wrapper.firstChild.classList.remove('overflow-auto')
        } else {
            wrapper.classList.toggle('open');
            wrapper.firstChild.classList.toggle('overflow-auto')
        }
    }  
}

function giveGift(giftmemberID, siteTranslationPath, config, giftKey, giftPrice) {
    return new Promise((resolve, reject) => {
        if (!storage.getStorage('sendingVirtualGift')) {
            showGiftPurchaseProgress()
            storage.setStorage('sendingVirtualGift', giftmemberID, giftKey)
            var formData = new FormData();
            formData.append('memberid', giftmemberID);
            formData.append('loggedinmemberid', config.memberID)
            formData.append('key', giftKey)
            formData.append('price', giftPrice)
            var URL = '/' + siteTranslationPath + '/profile/givevirtualGift?ajaxMode=true';
            var req = new XMLHttpRequest();
            req.url = URL;
            req.onload = function (req) {
                storage.clearStorage('sendingVirtualGift', giftmemberID)
                removeGiftPurchaseProgress()
                //the returned dataset should hold the state of the buy virtual gift flow.
                if (req.currentTarget.status == 200 && req.currentTarget.readyState === XMLHttpRequest.DONE) {
                    var result = JSON.parse(req.currentTarget.responseText)
                    resolve(result)
                } else {
                    reject('issue sending virtual gift')
                }
            }
            req.open('POST', URL);
            req.setRequestHeader("pragma", "no-cache");
            req.setRequestHeader("Cache-control", "no-store, must-revalidate, private");
            req.send(formData);
        }
    })
}

function showGiftPurchaseProgress() {
    //labels.noteProcessing
    // covers the icons with an overlay until the process is finished
    var currentChat = document.querySelector('[data-current-chat="true"]');

    var div = document.querySelector('[data-toggle-sparks-options]');
    var isModal = document.documentElement.classList.contains('modal-open');

    if (currentChat || div || isModal) {
        if (currentChat) {
            div = currentChat.querySelector('[data-toggle-sparks-options]')
        }
        if (isModal) {
            div = document.querySelector('.modal [data-toggle-sparks-options]')
        }

        if (div) {
            var processingLabel = window.cupidMedia.chatData.contentLabelList.processingNote
            var processHTML = '<div class="absolute top-0 left-0 bottom-0 right-0 flex items-center justify-center" data-process-note><div class="overlay p2 rounded white">'+processingLabel+'</div></div>';
            div.firstElementChild.append(document.createRange().createContextualFragment(processHTML))
        }
    }
}

function removeGiftPurchaseProgress() {
    var message = document.querySelector('[data-process-note]')
    if (message) {
        message.remove()

    }
}



function showHideVirtualGiftList(html,show) {
    var sparksOptions = html.querySelector('.chat-sparks-options');
    if (sparksOptions) {
        if(show){
            sparksOptions.classList.remove('hide') 
        } else {
            sparksOptions.classList.add('hide')
        }
    }
    
}

function showHideToggleButton(wrapperDiv){
    var giftOptionsListWrapper = wrapperDiv.querySelector('[data-toggle-sparks-options]')
    var list = giftOptionsListWrapper.firstChild
    var toggleButton = giftOptionsListWrapper.querySelector('[data-toggle-sparks]');

    if(list.clientHeight < list.scrollHeight){
        toggleButton.classList.remove('hide')
    } else {
        toggleButton.classList.add('hide')
    }
}

function updateSparksBalance(res){
    //find balance in Nav
    var navSparksBalance = document.querySelector('[data-sparks-balance]');
    if(navSparksBalance){
        navSparksBalance.textContent = res.sparksBalance
    }
}

function updateFreeGifts(currentTraget) {
    var vgSpecials = currentTraget.parentElement.querySelectorAll('[data-specials]')
    if (vgSpecials) {
        Array.from(vgSpecials).forEach(function (special) {
            // stop pointer events
            special.parentElement.classList.add('pointer-events-none');
            //set start burst opacity
            special.classList.add('opacity-4');
            //set gift icon opacity
            var gift = special.parentElement.querySelector('[data-vg-icon]')
            if (gift) {
                gift.classList.add('opacity-4');
            }
            // set sparks star and price opacity
            var price = special.parentElement.querySelector('[data-vg-price]')
            if (price) {
                price.classList.add('opacity-4');
            }

            var timer = special.parentElement.querySelector('[data-vg-timer]')
            if (timer == undefined) {
                var timerMarkup = document.createRange().createContextualFragment('<svg class="flex-none icon-20 absolute top-0 right-0 botton-0 left-0 mx-auto mt2" data-vg-timer><use xlink:href="' + cacheBuster + '#icon-stopwatch"></use></svg>');
                
                special.parentElement.append(timerMarkup)
            }
        })
    }
}

module.exports = {
    getVirtualGiftList: getVirtualGiftList,
    showHideVirtualGiftList:showHideVirtualGiftList,
    showHideToggleButton: showHideToggleButton,
    giveGift: giveGift,
    updateSparksBalance:updateSparksBalance
}